import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { BespokeAgreementsComponent } from './bespoke-agreements.component';

const routes: Routes = [
  { path: '', component: BespokeAgreementsComponent, data: { title: 'Bespoke Agreements' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BespokeAgreementsRoutingModule {}

@NgModule({
  imports: [
    BespokeAgreementsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [BespokeAgreementsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BespokeAgreementsModule {}
